import { StringHelper } from "../../../utilities/contracts/string-helper";

export class MemberChartItem {
  memberConflictFlag: boolean;
  tenantId: string;
  chartType: string;
  memberId: string;
  firstName: string;
  lastName: string;
  dob: string;
  gender: string;
  dateOfServiceFrom?: string;
  dateOfServiceTo?: string;
  dateOfServiceRange?: string;
  sourceSystem?: string;
  providerName?: string;
  groupName?: string;
  chartId: string;
  createTs?: string;
  updateTs?: string;
  trackingNumber?: string | null;
  totalPageCount?: number;
  fileName?: string;

  constructor(options: Partial<MemberChartItem> = {}) {
      this.memberConflictFlag = !!options.memberConflictFlag;
      this.tenantId = StringHelper.clean(options.tenantId);
      this.chartType = StringHelper.clean(options.chartType);
      this.memberId = StringHelper.clean(options.memberId);
      this.firstName = StringHelper.toTitleCase(StringHelper.clean(options.firstName));
      this.lastName = StringHelper.toTitleCase(StringHelper.clean(options.lastName));
      this.dob = StringHelper.clean(options.dob);
      this.gender = StringHelper.clean(options.gender);
      this.dateOfServiceFrom = StringHelper.clean(options.dateOfServiceFrom);
      this.dateOfServiceTo = StringHelper.clean(options.dateOfServiceTo);
      this.dateOfServiceRange = `${this.dateOfServiceFrom} - ${this.dateOfServiceTo}`;
      this.sourceSystem = StringHelper.clean(options.sourceSystem);
      this.providerName = StringHelper.toTitleCase(StringHelper.clean(options.providerName));
      this.groupName = StringHelper.toTitleCase(StringHelper.clean(options.groupName));
      this.chartId = StringHelper.clean(options.chartId);
      this.createTs = StringHelper.clean(options.createTs);
      this.updateTs = StringHelper.clean(options.updateTs);
      this.trackingNumber = options.trackingNumber ?? null;
      this.totalPageCount = options.totalPageCount;
      this.fileName = StringHelper.clean(options.fileName);
  }
}

